import React from 'react';
import { Card } from 'antd';
import { Resource } from 'rt-sd-common/sgiFactory/Resource';
import { uuid, uuidDate } from 'rt-sd-common/sgiCommon/sgiCommon';
import sgiConstants from 'rt-sd-common/sgiConstants/sgiConstants';
import { convertModuleByGuid } from "./SgiCompComm";
import { sgiCtnBaseFun } from "./SgiCtnComm";
import { getConstByKey } from './sgiBaseComp/SgiCommon';

export default class SgiOverlap extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            uuid: uuidDate(6, "yyyyMMddhhmmssSSS"),
            WrapProps: { style: { height: "100%", width: "100%" }, bodyStyle: { height: "100%", width: "100%" } },
            PanelItems: {},
            childItems: [],//子组件数组
            activeKey: '',
            // allDidMountCallback: {}//用于存放子组件自定义渲染后事件
        };
    }

    /**
     * 根据描述创建form
     * @param {父组件} parentModule
     * @param {描述} moduleDesc
     * @param {对象工厂} objFct
     * @param {make类型} type
     */
    Overlap_mk(parentModule, moduleDesc, objFct, type) {
        //获取需要展示的数据信息
        if (!moduleDesc) {
            return;
        }

        this.state.PanelItems = {}; //再次渲染的时候清空

        //转换基础属性
        this.AddAttribute(moduleDesc, this.state.WrapProps);

        var me = this;
        let cldSet = moduleDesc.cldSet;
        if (cldSet && cldSet.length && cldSet.length > 0) {
            cldSet.forEach((item, index) => {
                // let { cId } = item;
                let cId = getConstByKey(this, item.cId);
                cId = cId || this.state.uuid + "_" + index;
                if (index == 0 && !this.state.activeKey) this.state.activeKey = cId;
                let module = convertModuleByGuid(me, item, null, objFct, type, { setActiveWV: this.setActiveItem });
                // let module = convertModuleByGuid(me, item, null, objFct, type, { setActiveWV: this.setActiveItem, didMountCallback: allDidMountCallback[activeKey] });
                module.key = cId;
                this.state.PanelItems[cId] = module;
                this.saveItemDesc(cId, { module, parentModule: this, moduleDesc: item }, objFct);
                ComponentManager.set(objFct.getUID(), cId, module);
            });
        }
    }

    saveItemDesc(key, item, objFct) {
        if (!key || !objFct) return;

        let allWVItems = objFct.get(sgiConstants.allWVItemKey);
        if (!allWVItems) {
            allWVItems = {};
            objFct.set(sgiConstants.allWVItemKey, allWVItems);
        }
        allWVItems[key] = item;
    }

    setActiveItem = (activeKey, didMountCallback) => {
        this.state.activeKey = activeKey;
        let module = this.state.PanelItems[activeKey];
        if (module) module.props.didMountCallback = didMountCallback;
        this.setState({});
    }
    /**
     * 获取当前激活面板的组件标识
     * @return {[type]} [description]
     */
    getActiveItem = () => {
        return this.state.activeKey;
    }

    refresh = () => {
        this.loaded = false;
        this.setState({ loading: false });
    }


    //渲染并返回一个虚拟DOM
    render = function () {

        const { parentModule, moduleDesc, objFct, type } = this.props;

        if (!this.loaded || this.props.type == 'dnd') {
            //组装属性
            this.Overlap_mk(parentModule, moduleDesc, objFct, type);
            this.loaded = true;
        }

        const { PanelItems, activeKey, allDidMountCallback } = this.state;

        // let activeItem = PanelItems[activeKey];
        // if (!activeItem) {
        //     const cldSet = moduleDesc.cldSet || [];
        //     const me = this;
        //     cldSet.some((item, index) => {
        //         const cId = item.cId;
        //         if (cId === activeKey) {
        //             activeItem = convertModuleByGuid(me, item, null, objFct, type, { setActiveWV: this.setActiveItem, didMountCallback: allDidMountCallback[activeKey] });
        //             activeItem.key = activeItem.ref || activeItem.props.moduleDesc.cId || uuid(10);
        //             PanelItems[activeKey] = activeItem;
        //             this.saveItemDesc(cId, { module: activeItem, parentModule: this, moduleDesc: item }, objFct);
        //             ComponentManager.set(objFct.getUID(), cId, activeItem);
        //             return true;
        //         }
        //     });
        // }

        // 通用渲染前处理，添加自定义样式等
        this.renderBeforeReturn(this.state.WrapProps);

        return (
            <Card {...this.state.WrapProps}>
                {PanelItems[activeKey]}
            </Card>
        )
    }

    /**
     * 属性转换
     * @param {描述信息} moduleDesc
     * @param {属性} formProps
     */
    AddAttribute = function (moduleDesc, WrapProps) {
        //初始化激活的面板
        let atvTab = getConstByKey(this, moduleDesc.atvTab);
        if (atvTab) this.state.activeKey = atvTab;

        let isBrdr = moduleDesc.isBrdr; //是否有边框
        if (isBrdr) {
            WrapProps.bordered = true;
        } else {
            WrapProps.bordered = false;
        }

        if (moduleDesc.te || moduleDesc.teid) {//避免不必要的执行getTRByPrm()方法
            let title = Resource.getTRByPrm(moduleDesc).te; //是否有标题
            if (title) WrapProps.title = title;
        }

        var cId = moduleDesc.cId; //cid 唯一标示
        if (cId) WrapProps.id = getConstByKey(this, cId);

        var ctlW = moduleDesc.ctlW; //form宽度
        if (ctlW) WrapProps.style.width = ctlW;

        var ctlH = moduleDesc.ctlH; //form高度
        if (ctlH) WrapProps.style.height = ctlH;

        var mgn = moduleDesc.mgn; //form外边距
        if (mgn) WrapProps.bodyStyle.margin = mgn;
        var pad = moduleDesc.pad; //form内边距
        if (pad) WrapProps.bodyStyle.padding = pad;

        var isHdn = moduleDesc.isHdn; //form是否隐藏
        if (isHdn) WrapProps.style.display = "none";

        WrapProps.hoverable = false;//鼠标滑过 是否浮动，默认现在不浮动

        var isScl = moduleDesc.isScl; //滚动
        if (isScl) {
            WrapProps.style.overflow = "auto";
        } else {
            WrapProps.style.overflow = undefined;
        }
    }
}

//给类添加公共方法
Object.assign(SgiOverlap.prototype, sgiCtnBaseFun);


// WEBPACK FOOTER //
// ./~/rt-sd-comp/sgiComp/SgiOverlap.js